export default __webpack_public_path__ + "static/media/control-crops-img.17844ee6.jpg";